'use strict';
// rtc object
var rtc = {
	client: null,
	joined: false,
	published: false,
	localStream: null,
	remoteStreams: [],
	params: {},
},

//defined pusher global varibale
userType = null;
//add calling view
function addView(id, show) {
	if (!$("#" + id)[0]) {
		$("<div/>", {
			id: "remote_video_panel_" + id,
			class: "video-view",
		}).appendTo("#video");

		$("<div/>", {
			id: "remote_video_" + id,
			class: "video-placeholder remote-video",
		}).appendTo("#remote_video_panel_" + id);

		$("<div/>", {
			id: "remote_video_info_" + id,
			class: "video-profile " + (show ? "" : "hide"),
		}).appendTo("#remote_video_panel_" + id);

		$("<div/>", {
			id: "video_autoplay_" + id,
			class: "autoplay-fallback hide",
		}).appendTo("#remote_video_panel_" + id);
	}
}

//remove calling view
function removeView(id) {
	if ($("#remote_video_panel_" + id)[0]) {
		$("#remote_video_panel_" + id).remove();
	}
}

var __AudioVisualRequest = {
	handleCallEvents: function (rtc, userType, errorCallback, successCallBack) {

		// Occurs when the peer user leaves the channel; for example, the peer user calls Client.leave.
		rtc.client.on("peer-leave", function (evt) {
			var id = evt.uid;
			if (id != rtc.params.uid) {
				//remove audio/video calling view
				removeView();
			}

			successCallBack({
				'peer_leave': true
			});
		});

		// Occurs when the local stream is published.
		rtc.client.on("stream-published", function (evt) {
			//success call back
			successCallBack({
				'stream_publish' : true
			});
		});

		// Occurs when the remote stream is added.
		rtc.client.on("stream-added", function (evt) {
			var remoteStream = evt.stream;
			var id = remoteStream.getId();
			if (id !== rtc.params.uid) {
				rtc.client.subscribe(remoteStream, function (err) {
					/* handle the error */
					errorCallback({
						error: true,
						result: err
					});
				})
			}
		});

		// Occurs when a user subscribes to a remote stream.
		rtc.client.on("stream-subscribed", function (evt) {
			var remoteStream = evt.stream;
			var id = remoteStream.getId();
			rtc.remoteStreams.push(remoteStream);
			addView(id);
			remoteStream.play("remote_video_" + id);
			
			//success call back
			successCallBack({
				'stream_subscribe' : true
			});
		});

		// Occurs when the remote stream is removed; for example, a peer user calls Client.unpublish.
		rtc.client.on("stream-removed", function (evt) {
			var remoteStream = evt.stream;
			var id = remoteStream.getId();
			// Stop playing the remote stream.
			remoteStream.stop("remote_video_" + id);
			rtc.remoteStreams = rtc.remoteStreams.filter(function (stream) {
				return stream.getId() !== id
			})
			// Remove the view of the remote stream. 
			removeView(id);
		});
	},

	joinCall: function (requestData, userUid, userType, errorCallback, successCallBack) {
		// Options for joining a channel
		var option = {
			appID: requestData.agoraAppID,
			channel: requestData.channel,
			uid: userUid,
			token: requestData.token
		};

		// Create a client
		rtc.client = AgoraRTC.createClient({
			mode: "rtc",
			codec: "h264"
		});

		// handle AgoraRTC client event
		__AudioVisualRequest.handleCallEvents(rtc, userType, errorCallback, successCallBack);

		// Initialize the client
		rtc.client.init(option.appID, function () {

			// Join a channel
			rtc.client.join(option.token, option.channel, option.uid, function (uid) {
				
				rtc.params.uid = uid;

				//enable video by default false
				var enableVideo = false;
				//check call type is 2 (Video) then enable video
				if (requestData.callType == 2) {
					enableVideo = true;
				}

				// Create a local stream
				rtc.localStream = AgoraRTC.createStream({
					streamID: rtc.params.uid,
					audio: true,
					video: enableVideo,
					screen: false
				});

				//get user media related handle errors
				navigator.mediaDevices.getUserMedia({
					audio: true,
					video: enableVideo
				}).then(function (stream) {}).catch(function (err) {
					/* handle the error */
					errorCallback({
						error : true,
						result: err
					});
				});

				// Initialize the local stream
				rtc.localStream.init(function () {
				
					// play stream with html element id "local_stream"
					rtc.localStream.play("local_stream")

					// Publish the local stream
					rtc.client.publish(rtc.localStream, function (err) {
						/* handle the error */
						errorCallback({
							error : true,
							errortype : 'Publish stream error',
							result: err
						});
					});
					
				}, function (err) {
					/* handle the error */
					errorCallback({
						error : true,
						errortype : 'Local stream initialize error',
						result: err
					});
				});

			}, function (err) {
				/* handle the error */
				errorCallback({
					error : true,
					errortype : 'Join channel error',
					result: err
				});
				
			});
		}, function (err) {
			/* handle the error */
			errorCallback({
				error : true,
				errortype : 'Initialize client error',
				result: err
			});
		});
	},
	
	disconnectCall: function (pseudoCallback) {
		
		//check remote stream exists or not
		if (!rtc.client) {
			
			//success callback
			pseudoCallback({
				'peer_leave_failed' : true
			});
			return;
		}
		
		// Leave the channel
		rtc.client.leave(function () {

			// Stop playing the local stream
			rtc.localStream.stop();

			// Close the local stream
			rtc.localStream.close();

			// Stop playing the remote streams and remove the views
			while (rtc.remoteStreams.length > 0) {
				var stream = rtc.remoteStreams.shift();
				var id = stream.getId();
				stream.stop();
				//remove view
				removeView(id);
			}

			rtc.localStream = null;
			rtc.remoteStreams = [];
			rtc.client = null;
			rtc.published = false;
			rtc.joined = false;

			pseudoCallback({
				'call_disconnect': true
			});

		}, function (err) {
			//success callback
			pseudoCallback({
				'peer_leave_failed' : true,
				error : true,
				result: err
			});
		});
		
	},

	//unPublish stream when call disconnected
	unPublishStream: function(rtc) {
		if (!rtc.client) {
	        console.error("Please Join Room First");
	        return;
	     }
	    if (!rtc.published) {
	        console.error("Your didn't publish");
	        return;
	    }
	    var oldState = rtc.published;
     	rtc.client.unpublish(rtc.localStream, function (err) {
	        rtc.published = oldState;
	        console.log("unpublish failed");
	        console.error(err);
	    })
	    rtc.published = false;
	}
};